const deploy = {
  produccion: true
}

export default deploy;
